import React from 'react';
import { CUSTOMIZATION, BRAND } from '../../data/mock';
import { Button } from '../ui/button';
import { Gauge, CircleDollarSign, Percent, Stethoscope, Sparkles, ClipboardCheck, ArrowRight, Check } from 'lucide-react';

const iconMap = {
  Gauge,
  CircleDollarSign,
  Percent,
  Stethoscope,
  Sparkles,
  ClipboardCheck
};

export const Customization = () => {
  return (
    <section id="customization" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Flexible Coverage
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              {CUSTOMIZATION.title}
            </h2>
            <p className="text-lg text-slate-600 mb-10">
              {CUSTOMIZATION.subtitle}
            </p>

            {/* Options List */}
            <div className="space-y-4 mb-10">
              {CUSTOMIZATION.options.map((option, index) => {
                const IconComponent = iconMap[option.icon];
                return (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 bg-slate-50 rounded-xl hover:bg-teal-50 transition-colors group"
                  >
                    <div className="w-10 h-10 rounded-lg bg-white border border-slate-200 flex items-center justify-center group-hover:border-teal-300 group-hover:bg-teal-100 transition-colors">
                      <IconComponent className="w-5 h-5 text-teal-600" />
                    </div>
                    <span className="text-slate-700 font-medium">{option.text}</span>
                  </div>
                );
              })}
            </div>

            <Button
              asChild
              size="lg"
              className="text-white font-semibold shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40 transition-all"
              style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
            >
              <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
                Get Your Custom Quote
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </Button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={CUSTOMIZATION.image}
                alt="Owner caring for their pet"
                className="w-full h-auto object-cover aspect-square"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent" />
            </div>
            
            {/* Floating stats */}
            <div className="absolute -top-6 -right-6 bg-white rounded-2xl shadow-xl p-5 hidden md:block">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                  <Check className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="font-bold text-2xl text-slate-800">100%</p>
                  <p className="text-sm text-slate-500">Customizable Plans</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
